// Mock data for bHyyve website

export const mockData = {
  bookings: {
    total: 15847,
    today: 234,
    transactionVolume: 2847650,
    cities: [
      { name: "Toronto", count: 4523, trend: "+12%" },
      { name: "Ottawa", count: 2847, trend: "+8%" },
      { name: "Mississauga", count: 2156, trend: "+15%" },
      { name: "Hamilton", count: 1834, trend: "+10%" },
      { name: "London", count: 1523, trend: "+7%" },
      { name: "Kitchener", count: 1289, trend: "+9%" },
      { name: "Windsor", count: 987, trend: "+6%" },
      { name: "Vaughan", count: 876, trend: "+11%" },
      { name: "Markham", count: 812, trend: "+13%" },
      { name: "Barrie", count: 745, trend: "+5%" },
      { name: "Brampton", count: 698, trend: "+14%" },
      { name: "Guelph", count: 557, trend: "+8%" }
    ]
  },
  services: [
    {
      id: 1,
      title: "On-Demand Services",
      description: "Access a wide range of professional services at your fingertips, anytime, anywhere.",
      icon: "zap"
    },
    {
      id: 2,
      title: "Verified Professionals",
      description: "Connect with thoroughly vetted and highly-rated service providers in your area.",
      icon: "shield-check"
    },
    {
      id: 3,
      title: "Seamless Booking",
      description: "Book services in seconds with our intuitive platform and real-time availability.",
      icon: "calendar-check"
    },
    {
      id: 4,
      title: "Secure Payments",
      description: "Pay safely with our encrypted payment system and transparent pricing.",
      icon: "lock"
    },
    {
      id: 5,
      title: "24/7 Support",
      description: "Our dedicated support team is always ready to assist you with any questions.",
      icon: "headphones"
    },
    {
      id: 6,
      title: "Real-time Tracking",
      description: "Track your service provider in real-time and get instant updates on your booking.",
      icon: "map-pin"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Business Owner",
      content: "bHyyve has transformed how we manage our service needs. The platform is intuitive and the professionals are top-notch!",
      rating: 5
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Homeowner",
      content: "I've used bHyyve for various home services and I'm always impressed by the quality and speed of service delivery.",
      rating: 5
    },
    {
      id: 3,
      name: "Emma Williams",
      role: "Property Manager",
      content: "Managing multiple properties became so much easier with bHyyve. Highly recommend for anyone needing reliable services.",
      rating: 5
    }
  ],
  appLinks: {
    ios: "#ios-app",
    android: "#android-app",
    vendorIos: "#vendor-ios-app",
    vendorAndroid: "https://play.google.com/store/apps/details?id=com.partners.bhyyve&hl=en"
  },
  vendorBenefits: [
    {
      id: 1,
      title: "Flexible Schedule",
      description: "Work on your own terms. Choose when and how much you want to work.",
      icon: "clock"
    },
    {
      id: 2,
      title: "Steady Income Stream",
      description: "Access a constant flow of customers and build a reliable income source.",
      icon: "dollar-sign"
    },
    {
      id: 3,
      title: "Business Growth Tools",
      description: "Get access to analytics, marketing tools, and customer insights to grow your business.",
      icon: "trending-up"
    },
    {
      id: 4,
      title: "Secure Payments",
      description: "Fast, secure payments processed directly to your account. No hassle, no delays.",
      icon: "shield"
    },
    {
      id: 5,
      title: "Marketing Support",
      description: "Benefit from our platform marketing and customer acquisition efforts.",
      icon: "megaphone"
    },
    {
      id: 6,
      title: "24/7 Support",
      description: "Dedicated business support team available whenever you need assistance.",
      icon: "headset"
    }
  ],
  freeGyyfts: [
    {
      id: 1,
      name: "Free Service Credit",
      description: "$25 off your first booking",
      code: "GYYFTS-CREDIT-25",
      icon: "gift",
      color: "bg-yellow-400"
    },
    {
      id: 2,
      name: "Premium Trial",
      description: "30 days of Premium features",
      code: "GYYFTS-PREMIUM-30",
      icon: "crown",
      color: "bg-purple-400"
    },
    {
      id: 3,
      name: "Referral Bonus",
      description: "$10 for you and a friend",
      code: "GYYFTS-REFER-10",
      icon: "users",
      color: "bg-blue-400"
    },
    {
      id: 4,
      name: "Weekend Special",
      description: "20% off weekend bookings",
      code: "GYYFTS-WEEKEND-20",
      icon: "calendar",
      color: "bg-green-400"
    },
    {
      id: 5,
      name: "Early Bird",
      description: "15% off morning services",
      code: "GYYFTS-EARLY-15",
      icon: "sunrise",
      color: "bg-orange-400"
    },
    {
      id: 6,
      name: "Loyalty Reward",
      description: "Free upgrade on 5th booking",
      code: "GYYFTS-LOYAL-5",
      icon: "heart",
      color: "bg-red-400"
    }
  ],
  // Using a bee-themed video - you can replace this with your own video URL
  videoUrl: "https://cdn.pixabay.com/video/2023/07/28/173661-851024944_large.mp4"
};